import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { AbstractApiResponse } from '../../shared/models';
import { FollowUpReason } from '../models/follow-up-reason.interface';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class FollowUpReasonsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readFollowUpReason(iri: string): Observable<FollowUpReason> {
    return this.rolesService.userHasRoleFilter<FollowUpReason>(
      'ROLE_MWS_FOLLOW_UP_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readFollowUpReasons(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse | any>(
      'ROLE_MWS_FOLLOW_UP_VIEW',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(`/follow_up_reasons`)
    );
  }
}
